import Column from '@components/Column';
import CtaLayout from '@components/CtaLayout';
import Divider from '@components/Divider';
import Header from '@components/Header';
import styled from '@emotion/styled';
import useAppCustom from '@hooks/useAppCustom';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import useCopyRequest from '@store/order/hooks/useCopyRequest';
import { useTranslation } from 'react-i18next';

import CashReceipt from './components/CashReceipt';
import OrderDiscounts from './components/OrderDiscounts';
import OrderItems from './components/OrderItems';
import OrderNote from './components/OrderNote';
import OrderShopInfo from './components/OrderShopInfo';
import OrderTypeSelector from './components/OrderTypeSelector';
import PaymentMethod from './components/PaymentMethod';
import PointUse from './components/PointUse';
import PrepaidCardSection from './components/PrepaidCardSection';
import PurchaseFooter from './components/PurchaseFooter';
import PurchaseInfo from './components/PurchaseInfo';

interface Params {
  path?: 'cart' | 'direct';
  itemActivityId?: string;
}

declare module '@stackflow/config' {
    interface Register {
        OrderActivity: Params;
    }
}

const OrderActivity: ActivityComponentType<'OrderActivity'> = ({ params }) => {
    const { paymentOrderButtonPosition } = useAppCustom().payment;
    const { path, itemActivityId } = params;
    useCopyRequest(path, itemActivityId);
    const { t } = useTranslation('order');
    return (
        <AppScreen>
            <CtaLayout footerPosition={paymentOrderButtonPosition}
                header={<Header title={t('header.title')} />}
                footer={<PurchaseFooter/>} >
                <Column fullWidth>
                    <TopContents fullWidth spacing={2}>
                        <OrderShopInfo/>
                        <OrderItems/>
                    </TopContents>
                    <Divider/>
                    <OrderTypeSelector/>
                    <OrderNote/>
                    <Divider/>
                    <OrderDiscounts/>
                    <PointUse/>
                    <PrepaidCardSection/>
                    <CashReceipt/>
                    <Divider/>
                    <PaymentMethod/>
                    <Divider/>
                    <PurchaseInfo/>
                    {/* <OrderTermNotes/> */}
                    {/* 토스 결제위젯 영역 */}
                    <div id='payment-method' style={{ width: '100%' }}/>
                    <div id='agreement' style={{ width: '100%' }}/>
                </Column>
            </CtaLayout>
        </AppScreen>
    );
};

const TopContents = styled(Column)`
    padding: var(--spacing-6) 0
`;

export default OrderActivity;
